// Home page


/*==========================================================
  HERO SLIDER
==========================================================*/

(function () {

    'use strict';


    /*==========================
      Slider Elements
    ==========================*/

    const slider = document.querySelector('.hero-slider');

    const track = document.querySelector('.hero-slider__track');

    let slides = Array.from(
        document.querySelectorAll('.hero-slide')
    );

    const prevButton = document.querySelector(
        '.hero-slider__arrow--prev'
    );

    const nextButton = document.querySelector(
        '.hero-slider__arrow--next'
    );

    const dotsContainer = document.querySelector(
        '.hero-slider__dots'
    );


    /*
    Safety check
    */

    if (
        !slider ||
        !track ||
        slides.length === 0
    ) {

        return;

    }


    /*==========================
      Slider State
    ==========================*/

    let currentIndex = 1;

    let startX = 0;

    let currentX = 0;

    let isDragging = false;

    const swipeThreshold = 50;

    let autoSlideTimer = null;


    /*==========================
      Clone First & Last Slides
    ==========================*/

    if (slides.length > 1) {

        const firstClone =
            slides[0].cloneNode(true);

        const lastClone =
            slides[slides.length - 1].cloneNode(true);

        firstClone.classList.add('is-clone');

        lastClone.classList.add('is-clone');

        track.appendChild(firstClone);

        track.insertBefore(
            lastClone,
            slides[0]
        );

    }


    /*==========================
      Update slides after cloning
    ==========================*/

    slides = Array.from(
        document.querySelectorAll('.hero-slide')
    );


    /*
    If only one slide exists,
    don't create clones.
    */

    const originalSlideCount =
        slides.length > 1
            ? slides.length - 2
            : 1;


    /*==========================
      Create Dots
    ==========================*/

    if (dotsContainer) {

        dotsContainer.innerHTML = '';

        for (
            let i = 0;
            i < originalSlideCount;
            i++
        ) {

            const dot =
                document.createElement('button');

            dot.type = 'button';

            dot.className =
                'hero-slider__dot';

            dot.setAttribute(
                'aria-label',
                'Go to slide ' + (i + 1)
            );

            dot.addEventListener(
                'click',
                function () {

                    goToSlide(i + 1);

                    restartAutoSlide();

                }
            );

            dotsContainer.appendChild(dot);

        }

    }


    const dots = document.querySelectorAll(
        '.hero-slider__dot'
    );


    /*==========================
      Update Slider
    ==========================*/

    function updateSlider(
        animate = true
    ) {

        track.style.transition =
            animate
                ? 'transform 0.45s ease'
                : 'none';

        track.style.transform =
            'translateX(-' +
            (currentIndex * 100) +
            '%)';


        /* Update Active Dot */

        let activeDotIndex =
            currentIndex - 1;


        /* Last Clone */

        if (currentIndex === 0) {

            activeDotIndex =
                originalSlideCount - 1;

        }


        /* First Clone */

        if (
            currentIndex ===
            originalSlideCount + 1
        ) {

            activeDotIndex = 0;

        }


        dots.forEach(
            function (dot, index) {

                dot.classList.toggle(
                    'active',
                    index === activeDotIndex
                );

            }
        );

    }


    /*==========================
      Go To Specific Slide
    ==========================*/

    function goToSlide(index) {

        if (originalSlideCount <= 1) {

            currentIndex = 1;

            updateSlider(false);

            return;

        }

        currentIndex = index;

        updateSlider(true);

    }


    /*==========================
      Next Slide
    ==========================*/

    function nextSlide() {

        if (
            originalSlideCount <= 1
        ) {

            return;

        }

        if (
            currentIndex <
            originalSlideCount + 1
        ) {

            currentIndex++;

            updateSlider(true);

        }

    }


    /*==========================
      Previous Slide
    ==========================*/

    function previousSlide() {

        if (
            originalSlideCount <= 1
        ) {

            return;

        }

        if (
            currentIndex > 0
        ) {

            currentIndex--;

            updateSlider(true);

        }

    }


    /*==========================
      Seamless Loop
    ==========================*/

    track.addEventListener(
        'transitionend',
        function () {

            /*
            If we reach the first cloned slide,
            instantly move to the real last slide.
            */

            if (
                currentIndex ===
                originalSlideCount + 1
            ) {

                currentIndex = 1;

                updateSlider(false);

            }


            /*
            If we reach the last cloned slide,
            instantly move to the real last slide.
            */

            if (
                currentIndex === 0
            ) {

                currentIndex =
                    originalSlideCount;

                updateSlider(false);

            }

        }
    );


    /*==========================
      Auto Slide
    ==========================*/

    function startAutoSlide() {

        clearInterval(
            autoSlideTimer
        );


        if (
            originalSlideCount <= 1
        ) {

            return;

        }


        autoSlideTimer =
            setInterval(
                function () {

                    nextSlide();

                },
                5000
            );

    }


    /*==========================
      Restart Auto Slide
    ==========================*/

    function restartAutoSlide() {

        clearInterval(
            autoSlideTimer
        );

        startAutoSlide();

    }


    /*==========================
      Arrow Click Events
    ==========================*/

    if (nextButton) {

        nextButton.addEventListener(
            'click',
            function () {

                nextSlide();

                restartAutoSlide();

            }
        );

    }


    if (prevButton) {

        prevButton.addEventListener(
            'click',
            function () {

                previousSlide();

                restartAutoSlide();

            }
        );

    }


    /*==========================
      Mouse Drag - Desktop
    ==========================*/

    slider.addEventListener(
        'mousedown',
        function (event) {

            /*
            Don't start dragging when
            clicking arrow buttons or dots.
            */

            if (
                event.target.closest(
                    '.hero-slider__arrow'
                ) ||
                event.target.closest(
                    '.hero-slider__dot'
                )
            ) {

                return;

            }


            isDragging = true;

            startX = event.clientX;

            currentX = event.clientX;

            slider.classList.add(
                'is-dragging'
            );

        }
    );


    document.addEventListener(
        'mousemove',
        function (event) {

            if (!isDragging) {

                return;

            }

            currentX = event.clientX;

        }
    );


    document.addEventListener(
        'mouseup',
        function () {

            if (!isDragging) {

                return;

            }

            isDragging = false;

            slider.classList.remove(
                'is-dragging'
            );

            handleSwipe();

        }
    );


    /*==========================
      Touch Swipe - Mobile
    ==========================*/

    slider.addEventListener(
        'touchstart',
        function (event) {

            startX =
                event.touches[0].clientX;

            currentX =
                event.touches[0].clientX;

            isDragging = true;

        },
        {
            passive: true
        }
    );


    slider.addEventListener(
        'touchmove',
        function (event) {

            if (!isDragging) {

                return;

            }

            currentX =
                event.touches[0].clientX;

        },
        {
            passive: true
        }
    );


    slider.addEventListener(
        'touchend',
        function () {

            if (!isDragging) {

                return;

            }

            isDragging = false;

            handleSwipe();

        }
    );


    /*==========================
      Handle Swipe
    ==========================*/

    function handleSwipe() {

        const swipeDistance =
            currentX - startX;


        /* Swipe Left */

        if (
            swipeDistance <
            -swipeThreshold
        ) {

            nextSlide();

            restartAutoSlide();

        }


        /* Swipe Right */

        else if (
            swipeDistance >
            swipeThreshold
        ) {

            previousSlide();

            restartAutoSlide();

        }

    }


    /*==========================
      Keyboard Navigation
    ==========================*/

    document.addEventListener(
        'keydown',
        function (event) {

            if (
                event.key === 'ArrowLeft'
            ) {

                previousSlide();

                restartAutoSlide();

            }


            if (
                event.key === 'ArrowRight'
            ) {

                nextSlide();

                restartAutoSlide();

            }

        }
    );


    /*==========================
      Pause On Hover
    ==========================*/

    slider.addEventListener(
        'mouseenter',
        function () {

            clearInterval(
                autoSlideTimer
            );

        }
    );


    /*==========================
      Resume After Hover
    ==========================*/

    slider.addEventListener(
        'mouseleave',
        function () {

            startAutoSlide();

        }
    );


    /*==========================
      Initialize Hero Slider
    ==========================*/

    if (originalSlideCount > 1) {

        currentIndex = 1;

    } else {

        currentIndex = 0;

    }

    updateSlider(false);

    startAutoSlide();


})();



/*==========================================================
  PRODUCT SLIDER
==========================================================*/

(function () {

    'use strict';


    /*==========================
      Slider Elements
    ==========================*/

    const slider =
        document.querySelector(
            '.product-slider'
        );

    const viewport =
        document.querySelector(
            '.product-slider__viewport'
        );

    const track =
        document.querySelector(
            '.product-slider__track'
        );

    const prevButton =
        document.querySelector(
            '.product-slider__arrow--prev'
        );

    const nextButton =
        document.querySelector(
            '.product-slider__arrow--next'
        );


    if (
        !slider ||
        !viewport ||
        !track
    ) {

        return;

    }


    /*==========================
      Original Product Cards
    ==========================*/

    let originalCards =
        Array.from(
            track.querySelectorAll(
                '.product-card'
            )
        );


    const totalProducts =
        originalCards.length;


    if (
        totalProducts === 0
    ) {

        return;

    }


    /*==========================
      Determine Visible Cards
    ==========================*/

    function getVisibleCards() {

        const width =
            window.innerWidth;

        if (width <= 767) {

            return 1;

        }

        if (width <= 991) {

            return 2;

        }

        return 3;

    }


    /*==========================
      Slider State
    ==========================*/

    let visibleCards =
        getVisibleCards();

    let currentIndex =
        visibleCards;

    let isAnimating =
        false;

    let startX = 0;

    let currentX = 0;

    let isDragging = false;

    const swipeThreshold = 50;


    /*==========================
      Clone Cards
    ==========================*/

    function createClones() {

        track
            .querySelectorAll(
                '.product-card.is-clone'
            )
            .forEach(
                function (clone) {

                    clone.remove();

                }
            );


        /*
        Clone last visible cards
        */

        const prependCards =
            originalCards
                .slice(-visibleCards)
                .map(
                    function (card) {

                        const clone =
                            card.cloneNode(true);

                        clone.classList.add(
                            'is-clone'
                        );

                        return clone;

                    }
                );


        /*
        Clone first visible cards
        */

        const appendCards =
            originalCards
                .slice(0, visibleCards)
                .map(
                    function (card) {

                        const clone =
                            card.cloneNode(true);

                        clone.classList.add(
                            'is-clone'
                        );

                        return clone;

                    }
                );


        prependCards.forEach(
            function (clone) {

                track.insertBefore(
                    clone,
                    track.firstChild
                );

            }
        );


        appendCards.forEach(
            function (clone) {

                track.appendChild(
                    clone
                );

            }
        );

    }


    /*==========================
      Get Card Width
    ==========================*/

    function getCardWidth() {

        const card =
            track.querySelector(
                '.product-card'
            );

        if (!card) {

            return 0;

        }

        const cardStyle =
            window.getComputedStyle(
                card
            );

        const marginLeft =
            parseFloat(
                cardStyle.marginLeft
            ) || 0;

        const marginRight =
            parseFloat(
                cardStyle.marginRight
            ) || 0;


        return (
            card.offsetWidth +
            marginLeft +
            marginRight
        );

    }


    /*==========================
      Move Slider
    ==========================*/

    function moveSlider(
        animate = true
    ) {

        const cardWidth =
            getCardWidth();

        if (!cardWidth) {

            return;

        }

        track.style.transition =
            animate
                ? 'transform 0.45s ease'
                : 'none';

        track.style.transform =
            'translateX(-' +
            (
                currentIndex *
                cardWidth
            ) +
            'px)';

    }


    /*==========================
      Next Slide
    ==========================*/

    function nextProductSlide() {

        if (
            isAnimating ||
            totalProducts <= visibleCards
        ) {

            return;

        }

        isAnimating = true;

        currentIndex++;

        moveSlider(true);

    }


    /*==========================
      Previous Slide
    ==========================*/

    function previousProductSlide() {

        if (
            isAnimating ||
            totalProducts <= visibleCards
        ) {

            return;

        }

        isAnimating = true;

        currentIndex--;

        moveSlider(true);

    }


    /*==========================
      Seamless Infinite Loop
    ==========================*/

    track.addEventListener(
        'transitionend',
        function () {

            /*
            Reached cloned cards at end
            */

            if (
                currentIndex >=
                totalProducts +
                visibleCards
            ) {

                currentIndex =
                    visibleCards;

                moveSlider(false);

            }


            /*
            Reached cloned cards at beginning
            */

            if (
                currentIndex <
                visibleCards
            ) {

                currentIndex =
                    totalProducts;

                moveSlider(false);

            }

            isAnimating = false;

        }
    );


    /*==========================
      Arrow Events
    ==========================*/

    if (nextButton) {

        nextButton.addEventListener(
            'click',
            nextProductSlide
        );

    }


    if (prevButton) {

        prevButton.addEventListener(
            'click',
            previousProductSlide
        );

    }


    /*==========================
      Mouse Drag
    ==========================*/

    viewport.addEventListener(
        'mousedown',
        function (event) {

            if (
                event.target.closest(
                    'button'
                ) ||
                event.target.closest(
                    'input'
                )
            ) {

                return;

            }

            isDragging = true;

            startX =
                event.clientX;

            currentX =
                event.clientX;

            viewport.classList.add(
                'is-dragging'
            );

            track.style.transition =
                'none';

        }
    );


    document.addEventListener(
        'mousemove',
        function (event) {

            if (!isDragging) {

                return;

            }

            currentX =
                event.clientX;

        }
    );


    document.addEventListener(
        'mouseup',
        function () {

            if (!isDragging) {

                return;

            }

            isDragging = false;

            viewport.classList.remove(
                'is-dragging'
            );

            handleProductSwipe();

        }
    );


    /*==========================
      Touch Swipe
    ==========================*/

    viewport.addEventListener(
        'touchstart',
        function (event) {

            startX =
                event.touches[0].clientX;

            currentX =
                event.touches[0].clientX;

            isDragging = true;

        },
        {
            passive: true
        }
    );


    viewport.addEventListener(
        'touchmove',
        function (event) {

            if (!isDragging) {

                return;

            }

            currentX =
                event.touches[0].clientX;

        },
        {
            passive: true
        }
    );


    viewport.addEventListener(
        'touchend',
        function () {

            if (!isDragging) {

                return;

            }

            isDragging = false;

            handleProductSwipe();

        }
    );


    /*==========================
      Handle Swipe
    ==========================*/

    function handleProductSwipe() {

        const distance =
            currentX -
            startX;


        if (
            distance <
            -swipeThreshold
        ) {

            nextProductSlide();

        }

        else if (
            distance >
            swipeThreshold
        ) {

            previousProductSlide();

        }

        else {

            moveSlider(true);

        }

    }


    /*==========================
      Resize Handler
    ==========================*/

    let resizeTimer;

    window.addEventListener(
        'resize',
        function () {

            clearTimeout(
                resizeTimer
            );

            resizeTimer =
                setTimeout(
                    function () {

                        visibleCards =
                            getVisibleCards();


                        /*
                        Re-create clones
                        */

                        createClones();


                        /*
                        Reset slider position
                        */

                        currentIndex =
                            visibleCards;

                        moveSlider(false);


                        /*
                        Disable navigation
                        if all products
                        are visible
                        */

                        const shouldDisable =
                            totalProducts <=
                            visibleCards;


                        if (prevButton) {

                            prevButton.disabled =
                                shouldDisable;

                        }

                        if (nextButton) {

                            nextButton.disabled =
                                shouldDisable;

                        }

                    },
                    150
                );

        }
    );


    /*==========================
      Initialize Product Slider
    ==========================*/

    createClones();

    moveSlider(false);


    /*
    Disable arrows when there
    is nothing to slide.
    */

    if (
        totalProducts <=
        visibleCards
    ) {

        if (prevButton) {

            prevButton.disabled = true;

        }

        if (nextButton) {

            nextButton.disabled = true;

        }

    }


})();



/*==========================================================
  TESTIMONIAL / REVIEW SLIDER
==========================================================*/

(function () {

    'use strict';


    /*==========================
      Slider Elements
    ==========================*/

    const slider =
        document.querySelector(
            '.testimonials-slider'
        );

    const viewport =
        document.querySelector(
            '.testimonials-slider__viewport'
        );

    const track =
        document.querySelector(
            '.testimonials-slider__track'
        );

    const prevButton =
        document.querySelector(
            '.testimonials-slider__arrow--prev'
        );

    const nextButton =
        document.querySelector(
            '.testimonials-slider__arrow--next'
        );


    /*==========================
      Safety Check
    ==========================*/

    if (
        !slider ||
        !viewport ||
        !track
    ) {

        return;

    }


    /*==========================
      Original Cards
    ==========================*/

    let originalCards =
        Array.from(
            track.querySelectorAll(
                '.testimonial-card'
            )
        );


    const totalTestimonials =
        originalCards.length;


    if (
        totalTestimonials === 0
    ) {

        return;

    }


    /*==========================
      Visible Cards
    ==========================*/

    function getVisibleCards() {

        const width =
            window.innerWidth;

        if (width <= 767) {

            return 1;

        }

        if (width <= 991) {

            return 2;

        }

        return 4;

    }


    /*==========================
      Slider State
    ==========================*/

    let visibleCards =
        getVisibleCards();

    let currentIndex =
        visibleCards;

    let isAnimating =
        false;


    /*==========================
      Drag State
    ==========================*/

    let startX = 0;

    let currentX = 0;

    let isDragging = false;

    const swipeThreshold = 50;


    /*==========================
      Create Clones
    ==========================*/

    function createTestimonialClones() {

        track
            .querySelectorAll(
                '.testimonial-card.is-clone'
            )
            .forEach(
                function (clone) {

                    clone.remove();

                }
            );


        /*
        Clone last visible cards
        */

        const prependCards =
            originalCards
                .slice(-visibleCards)
                .map(
                    function (card) {

                        const clone =
                            card.cloneNode(true);

                        clone.classList.add(
                            'is-clone'
                        );

                        return clone;

                    }
                );


        /*
        Clone first visible cards
        */

        const appendCards =
            originalCards
                .slice(0, visibleCards)
                .map(
                    function (card) {

                        const clone =
                            card.cloneNode(true);

                        clone.classList.add(
                            'is-clone'
                        );

                        return clone;

                    }
                );


        /*
        Add clones before
        */

        prependCards.forEach(
            function (clone) {

                track.insertBefore(
                    clone,
                    track.firstChild
                );

            }
        );


        /*
        Add clones after
        */

        appendCards.forEach(
            function (clone) {

                track.appendChild(
                    clone
                );

            }
        );

    }


    /*==========================
      Get Card Width
    ==========================*/

    function getTestimonialCardWidth() {

        const card =
            track.querySelector(
                '.testimonial-card'
            );

        if (!card) {

            return 0;

        }


        const cardStyle =
            window.getComputedStyle(
                card
            );


        const marginLeft =
            parseFloat(
                cardStyle.marginLeft
            ) || 0;


        const marginRight =
            parseFloat(
                cardStyle.marginRight
            ) || 0;


        return (
            card.offsetWidth +
            marginLeft +
            marginRight
        );

    }


    /*==========================
      Move Slider
    ==========================*/

    function moveTestimonialSlider(
        animate = true
    ) {

        const cardWidth =
            getTestimonialCardWidth();


        if (!cardWidth) {

            return;

        }


        track.style.transition =
            animate
                ? 'transform 0.45s ease'
                : 'none';


        track.style.transform =
            'translateX(-' +
            (
                currentIndex *
                cardWidth
            ) +
            'px)';

    }


    /*==========================
      Next Testimonial
    ==========================*/

    function nextTestimonial() {

        if (
            isAnimating ||
            totalTestimonials <=
            visibleCards
        ) {

            return;

        }


        isAnimating = true;

        currentIndex++;

        moveTestimonialSlider(true);

    }


    /*==========================
      Previous Testimonial
    ==========================*/

    function previousTestimonial() {

        if (
            isAnimating ||
            totalTestimonials <=
            visibleCards
        ) {

            return;

        }


        isAnimating = true;

        currentIndex--;

        moveTestimonialSlider(true);

    }


    /*==========================
      Seamless Infinite Loop
    ==========================*/

    track.addEventListener(
        'transitionend',
        function () {


            /*
            Reached cloned cards
            at the end
            */

            if (
                currentIndex >=
                totalTestimonials +
                visibleCards
            ) {

                currentIndex =
                    visibleCards;

                moveTestimonialSlider(
                    false
                );

            }


            /*
            Reached cloned cards
            at the beginning
            */

            if (
                currentIndex <
                visibleCards
            ) {

                currentIndex =
                    totalTestimonials;

                moveTestimonialSlider(
                    false
                );

            }


            isAnimating = false;

        }
    );


    /*==========================
      Arrow Events
    ==========================*/

    if (nextButton) {

        nextButton.addEventListener(
            'click',
            nextTestimonial
        );

    }


    if (prevButton) {

        prevButton.addEventListener(
            'click',
            previousTestimonial
        );

    }


    /*==========================
      Mouse Drag
    ==========================*/

    viewport.addEventListener(
        'mousedown',
        function (event) {

            /*
            Don't drag when
            interacting with video
            controls.
            */

            if (
                event.target.closest(
                    'video'
                )
            ) {

                return;

            }


            isDragging = true;

            startX =
                event.clientX;

            currentX =
                event.clientX;

            viewport.classList.add(
                'is-dragging'
            );


            track.style.transition =
                'none';

        }
    );


    document.addEventListener(
        'mousemove',
        function (event) {

            if (!isDragging) {

                return;

            }


            currentX =
                event.clientX;

        }
    );


    document.addEventListener(
        'mouseup',
        function () {

            if (!isDragging) {

                return;

            }


            isDragging = false;

            viewport.classList.remove(
                'is-dragging'
            );


            handleTestimonialSwipe();

        }
    );


    /*==========================
      Touch Swipe
    ==========================*/

    viewport.addEventListener(
        'touchstart',
        function (event) {

            /*
            Don't interfere with
            video interaction.
            */

            if (
                event.target.closest(
                    'video'
                )
            ) {

                return;

            }


            startX =
                event.touches[0]
                    .clientX;

            currentX =
                event.touches[0]
                    .clientX;

            isDragging = true;

        },
        {
            passive: true
        }
    );


    viewport.addEventListener(
        'touchmove',
        function (event) {

            if (!isDragging) {

                return;

            }


            currentX =
                event.touches[0]
                    .clientX;

        },
        {
            passive: true
        }
    );


    viewport.addEventListener(
        'touchend',
        function () {

            if (!isDragging) {

                return;

            }


            isDragging = false;

            handleTestimonialSwipe();

        }
    );


    /*==========================
      Handle Swipe
    ==========================*/

    function handleTestimonialSwipe() {

        const distance =
            currentX -
            startX;


        /*
        Swipe Left
        */

        if (
            distance <
            -swipeThreshold
        ) {

            nextTestimonial();

        }


        /*
        Swipe Right
        */

        else if (
            distance >
            swipeThreshold
        ) {

            previousTestimonial();

        }


        /*
        Not enough movement
        */

        else {

            moveTestimonialSlider(
                true
            );

        }

    }


    /*==========================
      Resize Handler
    ==========================*/

    let resizeTimer;


    window.addEventListener(
        'resize',
        function () {

            clearTimeout(
                resizeTimer
            );


            resizeTimer =
                setTimeout(
                    function () {

                        visibleCards =
                            getVisibleCards();


                        /*
                        Rebuild clones
                        */

                        createTestimonialClones();


                        /*
                        Reset position
                        */

                        currentIndex =
                            visibleCards;


                        moveTestimonialSlider(
                            false
                        );

                    },
                    150
                );

        }
    );


    /*==========================
      Initialize
    ==========================*/

    createTestimonialClones();

    moveTestimonialSlider(false);


})();